import {ethers, BigNumber} from 'ethers';
import permit2ABI from './abi/permit2ABI.json';
import erc20 from './abi/erc20ABI.json';
import {SignatureTransfer} from '@uniswap/permit2-sdk';
import { getNextSpendAllowanceNonce } from '../../utils/apiEndpoints';

const ADDR = "0x000000000022d473030f116ddee9f6b43ac78ba3";
export class Permit2 {
    
    static async checkSpendAllowance(token, wallet) {
        if(!wallet) {
            throw new Error("No wallet provided");
        }
        if(!token) {
            throw new Error("Mising token");
        }

        const con = new ethers.Contract(token, erc20, wallet.ethersProvider);
        //see if spend allowance applied to target token
        const sa = await con.allowance(wallet.accounts[0].address, ADDR);
        return BigInt(sa.toString());
    }

    static async increaseSpendAllowance(token, wallet, amount) {
        if(!wallet) {
            throw new Error("No wallet provided");
        }
        if(!token) {
            throw new Error("Mising token");
        }
        const signer = wallet.ethersProvider.getSigner();
        const con = new ethers.Contract(token, erc20, signer);
        const txn = await con.approve(ADDR, BigNumber.from(amount.toString()));
        await txn.wait();
        return txn;
    }

    static async getSignerNonce(wallet, token, spender) {
        const con = new ethers.Contract(ADDR, permit2ABI, wallet.ethersProvider);
        let {amount, expiration, nonce} = await con.allowance(wallet.address, token.address, spender);
        return {
            amount,
            expiration,
            nonce: +(nonce.toString())+1
        }
    }
    
    static async signTransferFrom(props) {
        
        const { token, spender, amount, expiration, wallet} = props;
        if(!spender) {
            throw new Error("Missing spender for permitted allowance");
        }
        const signer = wallet.ethersProvider.getUncheckedSigner();
       
        let nonce = 0;
        const r = await getNextSpendAllowanceNonce({
            chainId: token.chainId,
            token: token.address,
            address: wallet.address
        });//await Permit2.getSignerNonce(wallet, token, spender);
    
        if(!r.result || !r.result.nextNonce) {
            throw new Error("Could not retrieve Permit2 signing nonce");
        }
        nonce = r.result.nextNonce;

        const {domain, types, values} = await SignatureTransfer.getPermitData({
            permitted: {
                token: token.address ? token.address : token,
                amount: amount.toString()
            },
            spender,
            //deposit should increase the nonce by additional sequence
            nonce,
            deadline: expiration
        }, ADDR, token.chainId);

        /*eslint no-underscore-dangle: "off"*/
		const sig = await signer._signTypedData(domain, types, values);
        const add = await ethers.utils.verifyTypedData(domain, types, values, sig);
        if(add.toLowerCase() !== wallet.address.toLowerCase()) {
            throw new Error("Signature not valid");
        }
        return {
            sig,
            nonce,
            token,
            amount,
            expiration
        }
    }
}